export default __webpack_public_path__ + "static/media/equupe_maa.e3ca6fdd.png";